import { useNavigate } from "react-router";
import { ServicesItemTypes } from "../../../utility/types/generaTypes";
import Button from "../../common/buttons/button/Button";
import GradientIcon from "../gradientIcon/GradientIcon";
import "./ServicesCard.css";

type ServicesCardProps = {
  service: ServicesItemTypes;
};
const ServicesCard = ({ service }: ServicesCardProps) => {
  const navigate = useNavigate();
  return (
    <div className="servicesCard_container">
      <div className="servicesCard_subContainer">
        <GradientIcon src={service?.icon} alt={service?.title + "_icon"} />
        <p className="services_title">{service?.title}</p>
        <p className="services_description">{service?.description}</p>
        {service.serviceAdvantages.map((item, index) => (
          <div
            className="service_advantage_points_container"
            key={"WHY_CHOOSE_US" + index}
          >
            <div className="point" />
            <p key={index}>{item}</p>
          </div>
        ))}
      </div>
      <Button
        title="Learn More"
        onClickButton={() => navigate(service?.to)}
        isSecodary
        className="serviceCard_learnMoreBtn"
        color="black"
      />
    </div>
  );
};

export default ServicesCard;
